import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { ContractStatusEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { Button, Checkbox, IconExpand } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import type { BimActKc2DataExtended } from '../types';

interface ICheckboxCellRendererComponent extends ICellRendererParams<BimActKc2DataExtended> {
    checkedIds: number[];
    setCheckedIds: React.Dispatch<React.SetStateAction<number[]>>;
    setCheckedActForDetails: React.Dispatch<React.SetStateAction<BimActKc2DataExtended>>;
    workOrderStatus?: WorkOrderStatusEnum;
    contractStatus?: ContractStatusEnum;
}

export const CheckboxCellRendererComponent: React.FC<ICheckboxCellRendererComponent> = (props) => {
    const { versionId } = useParams();
    const { data, checkedIds, workOrderStatus, contractStatus, setCheckedIds, setCheckedActForDetails } = props;
    const { isActRow, id, isInactive } = data || {};

    const isChecked = useMemo(() => checkedIds.includes(id), [checkedIds, id]);
    const isOpenTooltip = !data?.canRemoved;

    const isDisabledCheckbox = useMemo(() => {
        const isContractStatusDelayed = contractStatus === ContractStatusEnum.Delayed;
        const isContractStatusCompleted = contractStatus === ContractStatusEnum.Completed;

        const isWorkOrderStatusDelayed = workOrderStatus === WorkOrderStatusEnum.Delayed;
        const isWorkOrderStatusCompleted = workOrderStatus === WorkOrderStatusEnum.Completed;

        return (
            isWorkOrderStatusDelayed ||
            isWorkOrderStatusCompleted ||
            isContractStatusDelayed ||
            isContractStatusCompleted ||
            isInactive
        );
    }, [contractStatus, isInactive, workOrderStatus]);

    const onCheckChange = useCallback(() => {
        setCheckedIds((prevState) => {
            if (prevState.includes(id)) {
                return prevState.filter((f) => f !== id);
            }

            return [...prevState, id];
        });
    }, [id, setCheckedIds]);

    const checkActForDetails = useCallback(() => {
        if (data) {
            setCheckedActForDetails(data);
        }
    }, [data, setCheckedActForDetails]);

    return isActRow ? (
        <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            {isActRow && (
                <>
                    {!versionId && (
                        <TooltipWrapper
                            message="Акт загружен не в составе актуальной версии сметы. Удаление недоступно"
                            isHidden={!isOpenTooltip}
                            size="s"
                            direction="rightCenter"
                        >
                            <Checkbox
                                checked={isChecked}
                                onChange={onCheckChange}
                                style={{ padding: '4px' }}
                                disabled={isDisabledCheckbox || isOpenTooltip}
                            />
                        </TooltipWrapper>
                    )}
                    <Button
                        onClick={checkActForDetails}
                        iconLeft={IconExpand}
                        onlyIcon
                        view="clear"
                        size="xs"
                        style={{ marginLeft: 'auto' }}
                    />
                </>
            )}
        </div>
    ) : (
        <span />
    );
};

CheckboxCellRendererComponent.displayName = 'NumberCellRendererComponent';
